import React, { Component } from "react"
import { graphql, Link } from "gatsby";
import { scroller } from "react-scroll";
import { Helmet } from "react-helmet";
import { Tabs, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Layout from "../../components/layout";
import ReactReadMoreReadLess from "react-read-more-read-less";
import AwesomeSlider from 'react-awesome-slider';
import 'react-awesome-slider/dist/styles.css';
import withAutoplay from 'react-awesome-slider/dist/autoplay';
import ScrollAnimation from 'react-animate-on-scroll';
import "../../css/style.css";
import "../../css/animate.min.css";
import "../../css/responsive.css";
import "../../css/bootstrap.min.css";
import "../../css/swiper-bundle.min.css";
import InstituteTabs from "../../components/institutiontabs";
import Swiper, { Navigation, Pagination, Scrollbar, Autoplay, Thumbs, Mousewheel, Parallax } from 'swiper';
import PopupForm from "../../components/popupForm";
import ReactGA from 'react-ga'
import InstitutionsBannerSection from "./InstitutionsBannerSection";
import cardImg from '../../images/programs/degree.svg'
import cardImg1 from '../../images/programs/start online.svg'
import cardImg2 from '../../images/programs/get your visa.svg'
import cardImg3 from '../../images/programs/completed overseas.svg'
import UniversityCardView from '../../components/UniversityCardView'

Swiper.use([Navigation, Pagination, Autoplay, Scrollbar, Thumbs, Mousewheel, Parallax]);

const AutoplaySlider = withAutoplay(AwesomeSlider);

class University extends Component {
    componentDidMount() {
        var swiper = new Swiper('.universities-swiper', {
            slidesPerView: 3,
            slidesPerColumn: 2,
            spaceBetween: 30,
            observer: true,
            observeParents: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                // when window width is >= 320px
                320: {
                    slidesPerView: 1,
                    slidesPerColumn: 1,
                    spaceBetween: 0,
                    observer: true,
                    observeParents: true,
                },
                // when window width is >= 480px
                480: {
                    slidesPerView: 2,
                    slidesPerColumn: 2,
                    spaceBetween: 20,
                    observer: true,
                    observeParents: true,
                },
                // when window width is >= 640px
                768: {
                    slidesPerView: 3,
                    slidesPerColumn: 2,
                    spaceBetween: 30,
                    observer: true,
                    observeParents: true,
                }
            }
        });
        var swiper = new Swiper('.professors-swiper', {

            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                // bulletActiveClass: 'twinhealth-bullet'
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        });
    }


    constructor(props) {
        super(props);
        this.state = {
            time: 90000000
        }
    }
    scrollToSection = () => {
        scroller.scrollTo("universitie-partner-sec", {
            duration: 800,
            delay: 0,
            smooth: "easeInOutQuart",
        });
    };

    handlePopupWindow = () => {
        this.setState({ time: Math.random() })
    }
 
    render(){

        const uniArr = this.props.data.allWordpressWpUniversities.nodes

        const cardData = [
            {
                image: cardImg, title: "Choose Your University", text: "Get admission to a top US university in a stream of your choice - business, arts, engineering, technology and more"
            },
            {
                image: cardImg1, title: "Start Online", text: "Complete the first year of your degree online in just 10 months (6-8 credits per 7 week study period) and receive a transcript from a US university"
            },
            {
                image: cardImg2, title: "Get Your Visa", text: "Complete your visa process while studying and be ready to go to the US by the end of the All American Year 1 program"
            },
            {
                image: cardImg3, title: "Complete Overseas", text: "Progress to the overseas campus to complete the remainder of your degree and apply for post study work rights"
            }
        ]
   
        return(
        
            <div>
                <PopupForm time={this.state.time} />
                <Layout>
                    <Helmet>
                        <title>
                            Our Top Universities in USA | The WorldGrad
                        </title>
                        <meta
                            name="description"
                            content="Know about the most affordable and best universities in the USA, courses, tuition fees, visa requirements, and all the other details you need to pursue your dream of studying abroad via The WorldGrad."
                        />
                        <meta
                            name="keywords"
                            content="study in australia cost for indian students, study in australia cost, what is study in australia cost for indian students,"
                        />
                    </Helmet>
                    <div class="universitie-banner-sec">
                        <div class="container">
                            <div class="row">
                                <div class="col-12">
                                    <div class="universitie-banner-inner">
                                        <ul class="whitebackground breadcrumb">
                                            <li class="breadcrumb-item"><a href="/">The WorldGrad </a></li> 
                                            <li class="breadcrumb-item active">Institutions</li> 
                                        </ul>
                                        <InstitutionsBannerSection 
                                            country="USA's" 
                                            bannerUrl="https://media.publit.io/file/TheWorldgrad/3Institutions/USA/instituions-usa.jpg"
                                            altDescription="Statue of Liberty"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="universitie-partner-sec">
                        <div class="container">
                            <div class="row">
                                <div class="col-12">
                                    <div class="title">
                                        <h2>Our Partner Institutions</h2>
                                    </div>
                                    <Tabs>
                                        <TabPanel>
                                            <section id="marzen" class="tab-panel">
                                                <div class="interest-explore-inner">
                                                    <div class="swiper-container universities-swiper">
                                                        <div class="swiper-wrapper row justify-content-center m-0">
                                                            {
                                                                uniArr.map(university => {
                                                                    return (
                                                                        <div className="col-md-4" key={university.id}>
                                                                            <Link to={`/university-detail/${university.slug}`}>
                                                                                <div class="swiper-slide" value="Open" onClick={() => {
                                                                                    // this.openModal5()
                                                                                    ReactGA.event({
                                                                                        category: "Institutions",
                                                                                        action: "Clicks",
                                                                                        label: `UK - ${university.title}`
                                                                                    })
                                                                                }}>
                                                                                    <InstituteTabs
                                                                                        ImageUrl={university.acf.university_thumbnail.source_url}
                                                                                        // ImageUrl="https://media.publit.io/file/TheWorldgrad/3Institutions/Austrila/LaTrobe3_web-1333x1000_eoqnf5.jpg"
                                                                                        UniversityName={university.title}
                                                                                    />
                                                                                </div>
                                                                            </Link>
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                    
                                                    {/* <ScrollAnimation 
                                                        animateIn='fadeIn'
                                                        style = {{'animation-duration': '1s'}}
                                                    >
                                                        <a 
                                                            class="btn-default wow fadeInUp" 
                                                            data-wow-duration="1s" 
                                                            data-wow-delay=".1s" 
                                                            onClick={() => {this.handlePopupWindow()
                                                                ReactGA.event({
                                                                    category: "Institutions",
                                                                    action: "Clicks",
                                                                    label: "Enquire Now"
                                                                })
                                                            }} 
                                                        >
                                                            Speak With Us 
                                                        </a>  
                                                    </ScrollAnimation> */}
                                                </div>
                                            </section>
                                        </TabPanel>
                                    </Tabs>
                                </div>   
                            </div>     
                        </div>   
                    </div>

                    {/* <div className="row mb-5 d-flex align-items-center justify-content-center mx-1 mx-md-4">
                        <div className="col-md-6">
                            <img src="https://media.publit.io/file/TheWorldgrad/3Institutions/USA/USA.jpg" className="university-sample-image-img"/>   
                        </div>
                        <div className="col-md-6">
                            <UniversityCardView cardData={cardData} title={"Your American Degree Is Now A Lot More Accessible"} offer={"*Offer conditional on successful completion of the american dream Program"} />
                        </div>
                    </div> */}
        
                    {/* <div class="container">
                        <div class="row">
                            <div class="col-12">

                                <ScrollAnimation animateIn='fadeIn'
                                    style={{ 'animation-duration': '1s' }}>

                                    <div class="title">
                                        <h2 class="wow fadeInUp" data-wow-duration="1s" data-wow-delay=".7s">Testimonials</h2>
                                    </div>

                                </ScrollAnimation>

                                <div class="professors-inner wow fadeInUp" data-wow-duration="1s" data-wow-delay=".7s">
                                    <div class="swiper-container professors-swiper">
                                        <div class="swiper-wrapper">

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="professors-sec">
                        <div class="container"> 
                            <div class="newest-clas"> 
                                <div class="row"> 
                                    <div class="col-12">
                                        <ScrollAnimation animateIn='fadeIn'
                                            style={{ 'animation-duration': '1s' }}>

                                            <AutoplaySlider
                                                play={true}

                                                interval={6000}
                                            >

                                                <div class="swiper-slide">
                                                    <div class="professors-box">
                                                        <div class="image-holder">
                                                            <img src="https://res.cloudinary.com/worldgrad/image/upload/v1632308732/worldgrad/Testimonials/Kimi_Anderson_wyoyo8_pcxj5p.png" alt="" class="img-fluid" />
                                                        </div>
                                                        <div class="text-box">
                                                            <h4>Kimi Anderson</h4>
                                                            <span>Faculty (Marketing), SIBT</span>

                                                            <div>
                                                                <ReactReadMoreReadLess
                                                                    charLimit={300}
                                                                    readMoreText={"  Read more ▼"}
                                                                    readLessText={"Read less ▲"}
                                                                >
                                                                    “UniSmarter provides a wonderful pathway for students to accelerate their academic journeys. This program has been developed based on international standards, providing students with the opportunity to learn the course principles and participate in activities that showcase their understanding. The delivery, content, and activities of this program have been tailored to meet students' needs online, allowing them to enjoy a balance of lecture-style lessons and group discussions. The students also benefit from a teaching team's support, who are dedicated to helping the students embrace the unit and develop their study skills.”
                                                                </ReactReadMoreReadLess> </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="swiper-slide">
                                                    <div class="professors-box">
                                                        <div class="image-holder">
                                                            <img src="https://res.cloudinary.com/worldgrad/image/upload/v1632308379/worldgrad/Testimonials/Khaled_Halteh_fbyfww_1_gzlswe.png" alt="" class="img-fluid" />
                                                        </div>
                                                        <div class="text-box">
                                                            <h4>Dr. Khaled Halteh</h4>
                                                            <span>Assistant Professor Bond University & Online Coordinator, UniSmarter</span>


                                                            <div>
                                                                <ReactReadMoreReadLess
                                                                    charLimit={300}
                                                                    readMoreText={"  Read more ▼"}
                                                                    readLessText={"Read less ▲"}
                                                                >
                                                                    “UniSmarter is a great program for students that has been specifically tailored for online teaching – and is especially beneficial for students aspiring for global education. Students can gain invaluable insights from small-group webinars and tutorials, as well as one-on-one sessions with international educators from the comfort of their homes. This approach helps students to thrive in today’s e-learning environment, which is quickly reshaping the world of education.”
                                                                </ReactReadMoreReadLess> </div>

                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="swiper-slide">
                                                    <div class="professors-box">
                                                        <div class="image-holder">
                                                            <img src="https://res.cloudinary.com/worldgrad/image/upload/v1632310176/worldgrad/Testimonials/final-paul_ngc5ai.png" alt="" class="img-fluid" />
                                                        </div>
                                                        <div class="text-box">
                                                            <h4>Pauline McAlary</h4>
                                                            <span>Program Convenor, Sydney Institute of Business and Technology</span>


                                                            <div>
                                                                <ReactReadMoreReadLess
                                                                    charLimit={300}
                                                                    readMoreText={"  Read more ▼"}
                                                                    readLessText={"Read less ▲"}
                                                                >
                                                                    “UniSmarter offers various modules that are formally recognised as being equivalent to modules in our SIBT Diploma Programs. By successfully completing these modules with UniSmarter, students automatically receive advanced standing for those units in our Diploma Programs at SIBT in Sydney, Australia. UniSmarter students can then complete our Diploma in one session and progress through a guaranteed pathway to a degree in Business, Commerce or Information Technology at a highly regarded university in Australia. In my quality assurance role with UniSmarter, I have been very impressed with the amount of group and individual support that UniSmarter provides to all their students. Their constant focus is on the needs and best interests of their students. This assures me that UniSmarter students will come to us at the Sydney Institute of Business and Technology with knowledge that will set them up for academic success and an enjoyable learning journey.”
                                                                </ReactReadMoreReadLess> </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </AutoplaySlider>
                                        </ScrollAnimation>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </Layout>
            </div>
        )
    }
}


export default University;

export const WorldGradUniversities = graphql`
    {
        allWordpressWpUniversities(filter: {acf: {country: {eq: "USA"}}}) {
        nodes {
            id
            slug
            title
            acf {
                university_thumbnail {
                    source_url
                }
            }
        }
        }
    }
`
